import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { FaSignOutAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { logoutUserAsync } from "../redux/reducers/authReducer";
import withNavigate from "../hocs/withNavigate";
import withToast from "../hocs/withToast";
import lifeLeafLogo from "../assets/logo.png";
import { useTheme } from "@mui/material/styles";

const Navbar = ({ navigate, notify }) => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detects mobile view

  const handleLogout = () => {
    dispatch(logoutUserAsync())
      .unwrap()
      .then(() => {
        navigate("/login");
        notify("Logout successful", "success");
      })
      .catch((err) => {
        console.error("Logout failed", err);
        notify(err.message || "Logout failed", "error");
      });
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: "white", boxShadow: "none" }}>
      <Toolbar>
        <Box display="flex" alignItems="center" sx={{ flexGrow: 1 }}>
          <img src={lifeLeafLogo} width={40} height={40} alt="LifeLeaf Logo" />
          <Typography variant="h6" sx={{ fontWeight: "bold", ml: 1, color: "black" }}>
            LifeLeaf - Remote Monitoring
          </Typography>
        </Box>
        {isMobile ? ( // Mobile View: Show only logout icon
          <IconButton onClick={handleLogout} color="secondary">
            <FaSignOutAlt size={20} />
          </IconButton>
        ) : ( // Desktop & Tablet View: Show full button
          <Button
            variant="text"
            onClick={handleLogout}
            color="primary"
            startIcon={<FaSignOutAlt />}
          >
            Logout
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default withToast(withNavigate(Navbar));